import React from 'react';

function WorkspaceCheckList({ masterList, changeHandler, wrkMessage }) {
  return (
    <>
        <div className="wrkspace-chooser">
            {
                masterList.map( (thisWkspc) => {
                    // originally disabled public access, but now we are allowing it to be set by the user
                    let forcedCheckAndDisable = false;

                    return (
                        <div>
                            <input 
                                style={{ marginRight: '8px'}}
                                type="checkbox"
                                defaultChecked={forcedCheckAndDisable}
                                disabled={forcedCheckAndDisable}
                                id={ thisWkspc.tenantID } 
                                onChange={ changeHandler }
                            /> 
                            <label htmlFor={thisWkspc.tenantID}>{ thisWkspc.tenantSlug }</label>
                        </div>
                    )
                })
            }
        </div>
        <div className="working-message">
            {
                wrkMessage && wrkMessage !== '' ?
                    wrkMessage
                : null
            }
        </div>
    </>
  )
}

export default WorkspaceCheckList